import { render, staticRenderFns } from "./gameBanner.vue?vue&type=template&id=b2ce3050&scoped=true&"
import script from "./gameBanner.vue?vue&type=script&lang=ts&"
export * from "./gameBanner.vue?vue&type=script&lang=ts&"
import style0 from "./gameBanner.vue?vue&type=style&index=0&id=b2ce3050&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ce3050",
  null
  
)

export default component.exports